import { titleCase } from "@multicines/utils";
import { getLoyaltyTicketQtyAvailable } from "@multicines/utils";
import React, { useState } from "react";

import Styles from "./TicketsCategory.styles";
import { TicketsCategoryProps as Props } from "./TicketsCategory.types";
import ShoppingCartTicket from "../ShoppingCartTicket/ShoppingCartTicket";
import useI18n from "hooks/useI18n";

const TicketsCategory: React.FC<Props> = props => {
  const { category, disabled, onChange, remainingPoints } = props;
  const { onIsAdding, availableBenefitTickets } = props;
  const t = useI18n();
  const [localTicketCategoryCount, setLocalTicketCategoryCount] = useState(0);

  const { areaCategoryName } = category;
  const { products, seatsAvailable } = category;

  // If seatsAvailable is a number (including 0), use it to disable add button
  // If undefined, backend didn't return seats count (additional call) so don't disable or show availability
  const seatsAvailableIsNumber = typeof seatsAvailable === "number";

  const handleChange = (amount: number, prev: number) => {
    if (seatsAvailableIsNumber) {
      const newCount = amount - prev;
      setLocalTicketCategoryCount(prev => prev + newCount);
    }

    onChange(amount, prev);
  };

  const disableSeats = seatsAvailableIsNumber
    ? localTicketCategoryCount >= (seatsAvailable ?? 0)
    : false;
  const disableAdd = disabled || disableSeats;

  const isVipCategory = seatsAvailableIsNumber && areaCategoryName === "VIP";

  return (
    <Styles className="TicketsCategory">
      <div className="TicketsCategory__header">
        <p className="TicketsCategory__title">{titleCase(areaCategoryName)}</p>
        {isVipCategory ? (
          <div className="TicketsCategory__available-seats">
            <p className="TicketsCategory__available-seats-text">
              {t.movie.availableSeats}: {seatsAvailable ?? 0}
            </p>
          </div>
        ) : null}
      </div>
      {products.map(product => {
        const qtyAvailable = getLoyaltyTicketQtyAvailable(
          product,
          availableBenefitTickets
        );

        return (
          <ShoppingCartTicket
            key={product.productId}
            className="TicketsCategory__tickets"
            product={product}
            onChange={handleChange}
            disabledAdd={disableAdd}
            ticketCategory={areaCategoryName}
            remainingPoints={remainingPoints}
            onIsAdding={onIsAdding}
            qtyAvailable={qtyAvailable}
          />
        );
      })}
    </Styles>
  );
};

export default TicketsCategory;
